export default __webpack_public_path__ + "static/fryingPan-b5d75aadfdfcb41aa7839ffe267a678b.png";